import { liveValidatePattern } from '../validate/pattern';
import { liveValidateMaxLength } from '../validate/maxlength';
import { liveValidateMinLength } from '../validate/minlength';
import { liveValidateRequired } from '../validate/required';
import { liveValidateBlur } from '../validate/blur';
import { liveValidateSubmit, validateSubmit, autoFocusFirstOnSubmitError } from '../validate/submit';
import { setLoadingIndicator } from './loading-indicator';
import Ajax from '../lib/ajax';

const validateForumPostForm = (element: string) => {
    const form: HTMLFormElement | null = document.querySelector(element);

    if (form) {
        form.setAttribute('novalidate', 'novalidate');

        const inputs = [form.author, form.subject, form.body];

        for (const el of inputs) {
            liveValidateMinLength(el);
            liveValidateMaxLength(el);
            liveValidatePattern(el);
            liveValidateBlur(el);
            liveValidateRequired(el);
        }

        liveValidateSubmit(form);

        form.addEventListener('submit', function (this: HTMLFormElement, e: Event) {
            const errors = validateSubmit(inputs);
            const valid = errors.indexOf(false) === -1;

            e.preventDefault();

            if (!valid) {
                form.classList.add('focus-visible');
                autoFocusFirstOnSubmitError(this);
                e.preventDefault();

                return false;
            }

            return postForum(form);
        });
    }
};

const postForum = (form: HTMLFormElement): void => {
    const url: string | null = form.getAttribute('action');
    const formWrapper: HTMLDivElement | null = form.closest('#forum-post-message-wrapper');

    if (url && formWrapper) {
        setLoadingIndicator(form);

        const data = new FormData(form);
        const request: Ajax = new Ajax();
        request
            .postFormData(url, data)
            .then((response: Response) => {
                return response.text();
            })
            .then((body: string) => {
                formWrapper.innerHTML = body;
            });
    }
};

export { validateForumPostForm };
